import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'The Senior Benefit Unlocker';
render(<App data-id="element-626" />, document.getElementById('root'));